"use client";

import React from "react";
import Link from "next/link";

const Financing: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Making Invisalign Affordable: Payment and Financing Options
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Quality orthodontic care should be accessible to everyone.
          Here&apos;s a breakdown of options available to patients in Astoria
          and Queens:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Dental Insurance:</strong> Many plans cover a portion of
            treatment costs when orthodontic benefits are included. We&apos;ll
            help you maximize your coverage before treatment begins.
          </li>
          <li>
            <strong>HSA and FSA Funds:</strong> Clear aligner treatment is
            typically an eligible expense, which can meaningfully reduce
            out-of-pocket costs.
          </li>
          <li>
            <Link
              href="/financing-insurance/"
              className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out font-semibold"
            >
              Flexible Financing Plans
            </Link>
            : We offer extended, no-interest financing to spread the cost of
            treatment over time.
          </li>
        </ul>
        <p className="text-gray-800 text-base sm:text-lg leading-relaxed font-semibold pt-2">
          At Smile4Me Dental Care, we offer 0% interest financing for up to 2
          years, so the smile you&apos;ve been putting off is finally within
          reach!
        </p>
      </div>
    </section>
  );
};

export default Financing;
